/**
 * @desc: - 追号
 * @param  [String] windowId 多窗口模式的窗口ID
 * @param  [Function] 父级关闭弹窗的方法
 * @author: klaf
 * 使用方法     <TraceBox
                  windowId={this.windowId}
                  closeFn={this.closeTraceBox.bind(this)}
                />
   其他参数数据从reduce节点获取，const __methods = this.props.__METHOD.toJS(); __methods.windows[this.props.windowId]
 */
import ReactDOM from 'react-dom';
import { connect } from 'react-redux'

class TraceBox extends React.Component {

  constructor(props) {
    super(props);
    this.toggleTab = this.toggleTab.bind(this);
    this.numberAdd = this.numberAdd.bind(this);
    this.numberReduce = this.numberReduce.bind(this);
    this.togglePrizeStopCheck = this.togglePrizeStopCheck.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.getChaseResult = this.getChaseResult.bind(this);
    this.initEndResult = this.initEndResult.bind(this);
    this.initConfig = this.initConfig.bind(this);
    this.runMehtodForTotal = this.runMehtodForTotal.bind(this);
    this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
    this.handleInputChangeTimes = this.handleInputChangeTimes.bind(this);
    this.save = this.save.bind(this);
    this.cancel = this.cancel.bind(this);
    this.handleOnBlur = this.handleOnBlur.bind(this);
    this.difIssues = true; //控制奖期不同时更新频率
    this.state = {
      openWindow: false,//是否展示弹窗
      random: 9527,
      nowLay: 'lrvzh',//当前追号类型
      prizeStop: true,//中奖后停止
      startTimes: 1,//起始倍数
      minIncome: 50,//最低收益率
      chaseIssues: 10,//追号期数
      separateIssue: 1,//隔多少期
      doubledTimes: 2//翻多少倍
    }

    // 获取设置
    const __methods = this.props.__METHOD.toJS();
    let trace = __methods.windows[this.props.windowId].trace;
    this.defaultSubmit = __methods.windows[this.props.windowId].submit
    this.defaultDisplay = __methods.windows[this.props.windowId].display
    // 载入设置
    this.chaseConfig = {
      startTimes: trace.lt_trace_times_margin > 1 ? trace.lt_trace_times_margin : trace.lt_trace_times_same,                   //起始倍数
      minIncome: trace.lt_trace_margin,                                                                                        //最低收益率
      chaseIssues: trace.lt_trace_count_input,                                                                                 //追号期数
      separateIssue: trace.lt_trace_diff,                                                                                      //隔多少期
      doubledTimes: trace.lt_trace_times_diff,                                                                                 //翻多少倍
      totalIssues: 0,                                                                                                          //追号总期数
      totalNum:0,                                                                                                              //追号单期注数
      totalMoney: trace.lt_trace_money ? trace.lt_trace_money : 0                                                              //追号总金额
    }

    this.tabData = [
      { name: '利润率追号', hover: true, layout: 'lrvzh' },
      { name: '同倍追号', hover: false, layout: 'tbzh' },
      { name: '翻倍追号', hover: false, layout: 'fbzh' }
    ]
  }

  // 重置输入框
  initConfig() {
    // 获取设置
    const __methods = this.props.__METHOD.toJS();
    let trace = __methods.windows[this.props.windowId].trace;
    this.chaseConfig = {
      startTimes: 1,//起始倍数
      minIncome: 50,//最低收益率
      chaseIssues: 10,//追号期数
      separateIssue: 1,//隔多少期
      doubledTimes: 2,//翻多少倍
      totalIssues: 0,//追号总期数
      totalNum:0,//追号单期注数
      totalMoney: 0//追号总金额
    }
    this.setState({
      random: _.random(99999999)
    })
  }

  // 计算总期数和总金额
  runMehtodForTotal() {
    let submit = []
    let display = []
    const __methods = this.props.__METHOD.toJS();
    let windowId = this.props.windowId
    let id = __methods.windows[windowId].id
    const rate = __methods.windows[this.props.windowId].display[0].rate;
    var c = _.sum(_.map(__methods.windows[this.props.windowId].display, 'num'));
    let submitTimes = 0
    if(__methods.windows[this.props.windowId].submit.length > 1){
      _.forEach(__methods.windows[this.props.windowId].submit,(item)=>{
        submit.push({money:(item.money/item.times)*this.chaseConfig.startTimes,times:1*this.chaseConfig.startTimes})
        display.push({money:(item.money/item.times)*this.chaseConfig.startTimes,times:1*this.chaseConfig.startTimes + '倍'})
      })
      this.props.$$LOTTERY.updateOrder(submit, display, windowId, id)
      submitTimes = 1
    }else{
      submitTimes = _.sum(_.map(__methods.windows[this.props.windowId].submit, 'times'))
    }

    var total = 0;
    var money = 0;
    let trace = {
      "lt_trace_stop": this.state.prizeStop ? "yes" : "no",    //中奖后停止
      "lt_trace_times_margin": this.chaseConfig.startTimes,    //起始倍数
      "lt_trace_margin": this.chaseConfig.minIncome,           //最低收益率
      "lt_trace_times_same": this.chaseConfig.startTimes,      //起始倍数
      "lt_trace_diff": this.chaseConfig.separateIssue,         //隔多少期
      "lt_trace_times_diff": this.chaseConfig.doubledTimes,    //翻多少倍
      "lt_trace_count_input": this.chaseConfig.chaseIssues,    //追号期数
      "lt_trace_money": this.chaseConfig.totalMoney,           //追号总金额
      "lt_trace_issues": {}
    }
    _.forEach(this.endResult, function (item, key) {
      if (item.checked) {
        total = total + 1;//期数
        money = parseFloat(money) + parseFloat(item.money)
        trace.lt_trace_issues[item.issue] = item.times*submitTimes;
      }
    }.bind(this));

    // 更新统计数据
    this.chaseConfig.totalIssues = total;
    this.chaseConfig.totalNum = c
    this.chaseConfig.totalMoney = this.JsRound(money, 3, true);
    trace.lt_trace_money = this.chaseConfig.totalMoney
    trace.lt_trace_count_input = this.chaseConfig.totalIssues
    this.props.$$LOTTERY.setTrackInfo(trace, this.props.windowId);
    this.setState({
      random: _.random(99999999)
    })
  }


  // 取消tab的hover
  cancelAllHover() {
    _.forEach(this.tabData, function (item, key) {
      item.hover = false;
    });
  }

  // 选择tab的hover
  toggleTab(item) {
    this.cancelAllHover();
    item.hover = true;
    this.setState({
      nowLay: item.layout
    })
    this.props.$$LOTTERY.resetTrackInfo(this.props.windowId);
  }

  // 选择是否中奖后停止追号
  togglePrizeStopCheck() {
    this.setState({
      prizeStop: !this.state.prizeStop
    })
  }

  // +
  numberAdd(key) {
    this.chaseConfig[key] = Number(this.chaseConfig[key]) + 1;
    this.chaseConfig[key] = this.numberCheck(this.chaseConfig[key]);
    this.setState({
      random: _.random(99999999)
    })
  }

  // -
  numberReduce(key) {
    this.chaseConfig[key] = Number(this.chaseConfig[key]) - 1;
    this.chaseConfig[key] = this.numberCheck(this.chaseConfig[key]);
    this.setState({
      random: _.random(99999999)
    })
  }

  // 手动输入
  handleInputChange(key) {
    var newValue = ReactDOM.findDOMNode(this.refs[key]).value;
    // 整数
    newValue = parseInt(newValue);
    // NaN
    if (isNaN(newValue)) {
      return
    }
    this.chaseConfig[key] = newValue;
    this.chaseConfig[key] = this.numberCheck(this.chaseConfig[key]);
    ReactDOM.findDOMNode(this.refs[key]).value = this.chaseConfig[key]
  }
  handleOnBlur(key){
    var newValue = ReactDOM.findDOMNode(this.refs[key]).value;
    if(newValue == ""){
      newValue = 1
    }
    this.chaseConfig[key] = newValue;
    this.chaseConfig[key] = this.numberCheck(this.chaseConfig[key]);
    ReactDOM.findDOMNode(this.refs[key]).value = this.chaseConfig[key];
  }
  // 多选框
  handleCheckboxChange(item) {
    const __methods = this.props.__METHOD.toJS();
    const baseMoney  = _.sum(_.map(__methods.windows[this.props.windowId].submit, 'money'))
    item.checked = !item.checked;
    // 取消选择清空金额和倍数
    if (!item.checked) {
      item.times = 0;
      item.money = '0.000';
    }
    if (item.checked) {
      item.times = 1;
      item.money = this.JsRound(item.times * baseMoney, 3, true);
    }
    this.setState({
      random: _.random(99999999)
    })
    // 重新计算总额
    this.runMehtodForTotal();
  }

  // 输入倍数
  handleInputChangeTimes(item, ref) {
    const __methods = this.props.__METHOD.toJS();
    if(__methods.windows[this.props.windowId].submit.length > 1){
      _.forEach(__methods.windows[this.props.windowId].submit,(item)=>{
        item.money = item.money/item.times
      })
    }
    const baseMoney  = _.sum(_.map(__methods.windows[this.props.windowId].submit, 'money'))
    var newValue = ReactDOM.findDOMNode(this.refs[ref]).value;
    if(ReactDOM.findDOMNode(this.refs[ref]).value < 0){
      newValue = 1
    }
    ReactDOM.findDOMNode(this.refs[ref]).value = _.trimStart(newValue,0)
    item.times = this.JsRound(newValue, 0, true);
    item.money = this.JsRound(item.times * baseMoney, 3, true);
    // 重新计算总额
    this.runMehtodForTotal();
  }

  // 数字格式检测
  numberCheck(num) {
    if (num < 1) {
      num = 1;
    }
    if (num > 99999) {
      num = 99999;
    }
    return num;
  }

  // 根据利润率计算当期需要的倍数[起始倍数，利润率，单倍购买金额，历史购买金额，单倍奖金]，返回倍数
  computeByMargin(s, m, b, o, p) {
    s = s ? parseInt(s, 10) : 0;
    m = m ? parseInt(m, 10) : 0;
    b = b ? Number(b) : 0;
    o = o ? Number(o) : 0;
    p = p ? Number(p) : 0;
    var t = 0;
    if (b > 0) {
      if (m > 0) {
        t = Math.ceil(((m / 100 + 1) * o) / (p - (b * (m / 100 + 1))));
      } else {//无利润率
        t = 1;
      }
      if (t < s) {//如果最小倍数小于起始倍数，则使用起始倍数
        t = s;
      }
    }
    return t;
  }

  //四舍五入到指定精度,支持到整数位,类似PHP的round函数
  JsRound(num, len, keep) {
    len = parseInt(len, 10);
    if (len < 0) {
      len = Math.abs(len);
      return Math.round(Number(num) / Math.pow(10, len)) * Math.pow(10, len);
    }
    else if (len == 0) {
      return Math.round(Number(num));
    }
    num = Math.round(Number(num) * Math.pow(10, len)) / Math.pow(10, len);
    if (keep && keep == true) {
      var t = '', i = 0;
      num = num.toString();
      if (num.indexOf(".") == -1) {
        num = "" + num + ".0";
      }
      var data = num.split('.');
      for (i = data[1].length; i < len; i++) {
        t += '' + '0';
      }
      return '' + num + '' + t;
    }
    return num;
  }

  // 生成
  // 需要参数，1总投注注数，2methodid，3单注奖金，4是否多种玩法，5是否多种圆角分模式，6可追号期数，7单注金额
  getChaseResult() {
    const __methods = this.props.__METHOD.toJS();
    const isMulPlayMethod = _.chain(_.map(__methods.windows[this.props.windowId].submit, 'methodid')).uniqBy().value().length > 1 ? true : false;
    const isMulMode = _.chain(_.map(__methods.windows[this.props.windowId].submit, 'mode')).uniqBy().value().length > 1 ? true : false;
    const methodid = __methods.windows[this.props.windowId].submit[0].methodid;
    const track_issues = JSON.parse(__methods.windows[this.props.windowId].track_issue);
    const rate = __methods.windows[this.props.windowId].display[0].rate;
    var c = _.sum(_.map(__methods.windows[this.props.windowId].display, 'num'));//总投注注数
    let prize_group = __methods.windows[this.props.windowId].display[0].prize_group;//奖金组
    var p = (prize_group == null) ? 0 : parseFloat(prize_group[0].label.split('-')[0].substring(2));//单注奖金
    let prize_level = __methods.windows[this.props.windowId].display[0].prize_level;//奖级
    if (p == 0 && prize_level.length < 2) {
      let tmp = [];
      _.forEach(prize_level, (value, key) => {
        _.forEach(value, (val, k) => {
          tmp.push(val);
        })
      })
      p = _.min(tmp);
    }
    p = p * rate;
    var limit = __methods.windows[this.props.windowId].current_issue.current.track_limit;
    var t_count = limit >= this.endResult.length ?  this.endResult.length : limit;//可追号期数
    let base = 0  //单注金额
    _.forEach(__methods.windows[this.props.windowId].submit,(item)=>{
      if(__methods.windows[this.props.windowId].submit.length > 1){
        base = base + item.money/item.times
        item.times = 1
      }else{
        base = base + item.money
      }
    })
    if (c <= 0) {
      this.props.$$BASE.openAlert('请先添加投注内容');//lot_lang.am_s7
      return false;
    }
    // 利润率追号模式，首先检测是否支持
    if (this.state.nowLay == 'lrvzh') {
      //利润率支持情况，0：支持，1：玩法不支持，2：多玩法，3：多圆角模式
      var martype = 0;
      var noneed = [371, 373, 375, 377, 379, 381, 383];
      if (p <= 0 || (noneed.indexOf(methodid) > -1)) {
        martype = 1;
        this.props.$$BASE.openAlert('此玩法不支持利润率追号，请用其他追号方式');//lot_lang.am_s32
        return false;
      }

      if (isMulPlayMethod) {
        martype = 2;
        this.props.$$BASE.openAlert('多玩法不支持利润率追号，请选择单一玩法进行投注');//lot_lang.am_s31
        return false;
      }

      if (isMulMode) {
        martype = 3;
        this.props.$$BASE.openAlert('多圆角模式不支持利润率追号，请选择单一圆角模式');//lot_lang.am_s33
        return false;
      }
    }

    // 追号总期数
    var ic = this.chaseConfig.chaseIssues;
    ic = isNaN(ic) ? 0 : ic;
    if (ic <= 0) {//期数没有填
      this.props.$$BASE.openAlert('请填写追号期数');//lot_lang.am_s8
      return false;
    }
    if (ic > t_count) {//超过可追号期数
      this.props.$$BASE.openAlert('追号期数不正确，超出了最大可追号期数');//lot_lang.am_s9
      ReactDOM.findDOMNode(this.refs['chaseIssues']).value = t_count;
      this.handleInputChange('chaseIssues');
      return false;
    }
    var times = parseInt(this.state.nowLay == 'fbzh' ? this.chaseConfig.doubledTimes : this.chaseConfig.startTimes);//倍数，当前追号方式里的倍数
    times = isNaN(times) ? 0 : times;
    if (times <= 0) {
      this.props.$$BASE.openAlert('请填写倍数');//lot_lang.am_s10
      return false;
    }

    var td = [];//根据用户填写的条件生成的每期数据
    var tm = 0;//生成后的总金额
    var msg = '';//提示信息
    if (this.state.nowLay == 'tbzh') {//同倍
      var m = base * times;//每期金额
      tm = m * ic;//总金额=每期金额*期数
      for (var i = 0; i < ic; i++) {
        td.push({ times: times, money: m });
      }
      //同倍追号：1倍，确定要追号10期？
      msg = '<strong>同倍追号</strong>：&nbsp;&nbsp;[times] 倍<br /><br />确定要追号 [count] 期？';
      msg = msg.replace('[times]', this.chaseConfig.startTimes);
      msg = msg.replace('[count]', this.chaseConfig.chaseIssues);
    }
    if (this.state.nowLay == 'fbzh') {//翻倍
      var d = parseInt(this.chaseConfig.separateIssue);//相隔期数
      d = isNaN(d) ? 0 : d;
      if (d <= 0) {
        this.props.$$BASE.openAlert('请填写相隔期数');//lot_lang.am_s11
        return false;
      }
      var m = base;//每期基础金额
      var t = this.chaseConfig.startTimes;//起始倍数
      for (var i = 0; i < ic; i++) {
        if (i != 0 && ((i % d) == 0)) {
          t *= times;
        }
        td.push({ times: t, money: m * t });
        tm += m * t;
      }
      //翻倍追号，相隔1期x2倍，确定要追号10期吗？
      msg = '<strong>翻倍追号：</strong><br /><br />相隔 [step] 期 x [times] 倍，起始倍数：[startTimes]<br /><br />确定要追号 [count] 期？';
      msg = msg.replace('[step]', this.chaseConfig.separateIssue);
      msg = msg.replace('[times]', this.chaseConfig.doubledTimes);
      msg = msg.replace('[count]', this.chaseConfig.chaseIssues);
      msg = msg.replace('[startTimes]', this.chaseConfig.startTimes);
    }
    if (this.state.nowLay == 'lrvzh') {//利润率
      var e = parseInt(this.chaseConfig.minIncome);//最低利润率
      e = isNaN(e) ? 0 : e;
      if (e <= 0) {
        this.props.$$BASE.openAlert('利润率错误');//lot_lang.am_s30
        return false;
      }
      var m = base;//每期金额初始值
      if (e >= (p * 100 / m - 100)) {
        this.props.$$BASE.openAlert('利润率错误');//lot_lang.am_s30
        return false;
      }
      var t = 0;//返回的倍数
      for (var i = 0; i < ic; i++) {
        t = this.computeByMargin(times, e, m, tm, p);
        td.push({ times: t, money: m * t });
        tm += m * t;
      }
      //利润率追号：，最低利润率：50，起始倍数：1，确定要追号10期？
      msg = '<strong>利润率追号：</strong><br /><br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;最低利润率：[margin]，起始倍数：[times]<br /><br />确定要追号 [count] 期？';
      msg = msg.replace('[margin]', this.chaseConfig.minIncome);
      msg = msg.replace('[times]', this.chaseConfig.startTimes);
      msg = msg.replace('[count]', this.chaseConfig.chaseIssues);
    }

    // confirm(msg)
    this.props.$$BASE.openConfirm(msg, function () {
      // TODO:合并数据
      this.initEndResult();
      _.forEach(td, function (item, key) {
        this.endResult[key].times = item.times;
        this.endResult[key].money = this.JsRound(item.money, 3, true);
        this.endResult[key].checked = true;
      }.bind(this));
      // 计算总期数和金额
      this.runMehtodForTotal();
      if (this.chaseConfig.totalMoney <= 0) return;
    }.bind(this))
  }

  getChanseMsg() {
    const __methods = this.props.__METHOD.toJS();

    const isMulPlayMethod = _.chain(_.map(__methods.windows[this.props.windowId].submit, 'methodid')).uniqBy().value().length > 1 ? true : false;
    const isMulMode = _.chain(_.map(__methods.windows[this.props.windowId].submit, 'mode')).uniqBy().value().length > 1 ? true : false;
    const methodid = __methods.windows[this.props.windowId].submit[0].methodid;
    const track_issues = JSON.parse(__methods.windows[this.props.windowId].track_issue);
    const rate = __methods.windows[this.props.windowId].display[0].rate;
    var c = _.sum(_.map(__methods.windows[this.props.windowId].display, 'num'));//总投注注数
    let prize_group = __methods.windows[this.props.windowId].display[0].prize_group;//奖金组
    var p = (prize_group == null) ? 0 : parseFloat(prize_group[0].label.split('-')[0].substring(2));//单注奖金
    var limit = __methods.windows[this.props.windowId].current_issue.current.track_limit;
    var t_count = limit >= this.endResult.length ?  this.endResult.length : limit;//可追号期数
    const base  = _.sum(_.map(__methods.windows[this.props.windowId].display, 'money'))//单注金额
    if (c <= 0) {
      return false;
    }
    // 利润率追号模式，首先检测是否支持
    if (this.state.nowLay == 'lrvzh') {
      //利润率支持情况，0：支持，1：玩法不支持，2：多玩法，3：多圆角模式
      var martype = 0;
      var noneed = [371, 373, 375, 377, 379, 381, 383];
      if (p <= 0 || (noneed.indexOf(methodid) > -1)) {
        martype = 1;
        return false;
      }

      if (isMulPlayMethod) {
        martype = 2;
        return false;
      }

      if (isMulMode) {
        martype = 3;
        return false;
      }
    }

    // 追号总期数
    var ic = this.chaseConfig.chaseIssues;
    ic = isNaN(ic) ? 0 : ic;
    if (ic <= 0) {//期数没有填
      return false;
    }
    if (ic > t_count) {//超过可追号期数
      // TODO：填充为最大可追号期数？
      return false;
    }
    var times = parseInt(this.state.nowLay == 'fbzh' ? this.chaseConfig.doubledTimes : this.chaseConfig.startTimes);//倍数，当前追号方式里的倍数
    times = isNaN(times) ? 0 : times;
    if (times <= 0) {
      return false;
    }

    var td = [];//根据用户填写的条件生成的每期数据
    var tm = 0;//生成后的总金额
    if (this.state.nowLay == 'tbzh') {//同倍
      var m = base * times;//每期金额
      tm = m * ic;//总金额=每期金额*期数
      for (var i = 0; i < ic; i++) {
        td.push({ times: times, money: m });
      }
    }
    if (this.state.nowLay == 'fbzh') {//翻倍
      var d = parseInt(this.chaseConfig.separateIssue);//相隔期数
      d = isNaN(d) ? 0 : d;
      if (d <= 0) {
        // this.props.$$BASE.openAlert('请填写相隔期数');//lot_lang.am_s11
        return false;
      }
      var m = base;//每期基础金额
      var t = 1;//起始倍数
      for (var i = 0; i < ic; i++) {
        if (i != 0 && ((i % d) == 0)) {
          t *= times;
        }
        td.push({ times: t, money: m * t });
        tm += m * t;
      }
    }
    if (this.state.nowLay == 'lrvzh') {//利润率
      var e = parseInt(this.chaseConfig.minIncome);//最低利润率
      e = isNaN(e) ? 0 : e;
      if (e <= 0) {
        // this.props.$$BASE.openAlert('利润率错误');//lot_lang.am_s30
        return false;
      }
      var m = base;//每期金额初始值
      if (e >= (p * 100 / m - 100)) {
        // this.props.$$BASE.openAlert('利润率错误');//lot_lang.am_s30
        return false;
      }
      var t = 0;//返回的倍数
      for (var i = 0; i < ic; i++) {
        t = this.computeByMargin(times, e, m, tm, p);
        td.push({ times: t, money: m * t });
        tm += m * t;
      }
    }
    return td;
  }

  componentWillReceiveProps(nextProps) {
    const __methods = nextProps.__METHOD.toJS();
    if (this.endResult) {
      if ((__methods.windows[nextProps.windowId].current_issue.current.issue !== this.endResult[0].issue)&& this.difIssues) {
        //防止奖期不同时无限制的执行下面的代码
        this.difIssues = false
        this.initConfig();
        this.initEndResult();
        let td = this.getChanseMsg();
        _.forEach(td, function (item, key) {
          this.endResult[key].times = 0;
          this.endResult[key].money = 0;
          this.endResult[key].checked = false;
        }.bind(this));
        this.runMehtodForTotal();
      }else{
        this.difIssues = true
      }
      return;
    }
    this.initEndResult();
  }
  //卸载组件 恢复滚动条
  componentWillUnmount(){
    $.enableScroll()
  }
  //加载组件时，隐藏滚动条
  componentDidMount() {
    $.disableScroll();
    this.initEndResult();

    if (!this.endResult) {
      return;
    }

    // 获取设置
    const __methods = this.props.__METHOD.toJS();
    const rate = __methods.windows[this.props.windowId].display[0].rate;
    const num = _.sum(_.map(__methods.windows[this.props.windowId].display, 'num'))
    let trace = __methods.windows[this.props.windowId].trace;
    let all = trace.lt_trace_issues;
    // 载入设置
    _.forEach(this.endResult, function (item, key) {
      if (all[item.issue]) {
        item.checked = true;
        item.times = all[item.issue];
        item.money = this.JsRound(item.times * num * rate * 2, 3, true);
      }
    }.bind(this));

    // 获取总数
    this.chaseConfig.totalIssues = _.size(trace.lt_trace_issues);
  }

  // 保存所有设置
  save() {
    if (this.chaseConfig.totalMoney <= 0) return;
    const __methods = this.props.__METHOD.toJS();
    if (__methods.windows[this.props.windowId].display.length == 0) { return };
    const { closeFn, submit } = this.props;
    closeFn();
    submit();
  }

  // 取消追号
  cancel() {
    // 重置数据
    const __methods = this.props.__METHOD.toJS();
    let id = __methods.windows[this.props.windowId].id
    this.initEndResult();
    this.initConfig();
    this.props.$$LOTTERY.resetTrackInfo(this.props.windowId);
    this.props.$$LOTTERY.updateOrder(this.defaultSubmit, this.defaultDisplay, this.props.windowId, id)
    const { closeFn } = this.props;
    closeFn();
  }

  // 初始化奖期数据
  initEndResult() {
    const __methods = this.props.__METHOD.toJS();
    const track_limit = __methods.windows[this.props.windowId].current_issue.current.track_limit;
    const track_issues = JSON.parse(__methods.windows[this.props.windowId].track_issue);

    this.endResult = track_issues;
    this.endResult = _.chain(this.endResult).sortBy('issue').filter((item, index) => index < track_limit).value();

    this.setState({
      random: _.random(99999999)
    })
  }

  render() {
    const { closeFn } = this.props;
    const __methods = this.props.__METHOD.toJS();
    return (
      <div className="TraceBoxContent">
        <div className="blockOverlayBox" style={{ 'display': 'block' }}></div>
        <div className="zhBox" style={{ 'display': 'block' }}>
          <h4><i></i><span className="closeTraceBox" onClick={this.cancel}></span></h4>
          <div className="zTab">
            <div className="checkZhui right tzzhBox" onClick={this.togglePrizeStopCheck}>
              <span className={this.state.prizeStop ? 'check' : 'uncheck'}></span>中奖后停止追号
            </div>
            <ul>
              {
                this.tabData.map((item, index) => {
                  return <li key={index} className={item.hover ? 'hover' : ''} onClick={this.toggleTab.bind(this, item)}>
                    <a>{item.name}</a>
                  </li>
                })
              }
            </ul>
          </div>

          <div className="zCon">
            <div className="cRight right">
              <input type="button" value="生成" onClick={this.getChaseResult} />
            </div>
            <div className="cLeft left">

              <span>

                <div className="group">
                  <span>追号倍数：</span>
                  <div className="tools" key={this.chaseConfig.startTimes}>
                    <span className="reduce" onClick={this.numberReduce.bind(this, 'startTimes')}>-</span>
                    <input type="number" defaultValue={this.chaseConfig.startTimes} ref='startTimes' onBlur={this.handleOnBlur.bind(this, 'startTimes')} onChange={this.handleInputChange.bind(this, 'startTimes')} />
                    <span className="add" onClick={this.numberAdd.bind(this, 'startTimes')}>+</span>
                  </div>
                </div>

                <div className="group" style={{ 'display': (this.state.nowLay == 'lrvzh') ? 'block' : 'none' }}>
                  <span>最低收益率：</span>
                  <div className="tools" key={this.chaseConfig.minIncome}>
                    <span className="reduce" onClick={this.numberReduce.bind(this, 'minIncome')}>-</span>
                    <input type="number" defaultValue={this.chaseConfig.minIncome} ref='minIncome' onBlur={this.handleOnBlur.bind(this, 'minIncome')} onChange={this.handleInputChange.bind(this, 'minIncome')} />
                    <span className="add" onClick={this.numberAdd.bind(this, 'minIncome')}>+</span>
                  </div>
                  <em className="char-persent">%</em>
                </div>

                <div className="group" style={{ 'display': (this.state.nowLay == 'fbzh') ? 'block' : 'none' }}>
                  <span>隔</span>
                  <div className="tools" key={this.chaseConfig.separateIssue}>
                    <span className="reduce" onClick={this.numberReduce.bind(this, 'separateIssue')}>-</span>
                    <input type="number" defaultValue={this.chaseConfig.separateIssue} ref='separateIssue' onBlur={this.handleOnBlur.bind(this, 'separateIssue')} onChange={this.handleInputChange.bind(this, 'separateIssue')} />
                    <span className="add" onClick={this.numberAdd.bind(this, 'separateIssue')}>+</span>
                  </div>
                  <span>期</span>
                </div>

                <div className="group" style={{ 'display': (this.state.nowLay == 'fbzh') ? 'block' : 'none' }}>
                  <span>倍x</span>
                  <div className="tools" key = {this.chaseConfig.doubledTimes}>
                    <span className="reduce" onClick={this.numberReduce.bind(this, 'doubledTimes')}>-</span>
                    <input type="number" defaultValue={this.chaseConfig.doubledTimes} ref='doubledTimes' onBlur={this.handleOnBlur.bind(this, 'doubledTimes')} onChange={this.handleInputChange.bind(this, 'doubledTimes')} />
                    <span className="add" onClick={this.numberAdd.bind(this, 'doubledTimes')}>+</span>
                  </div>
                </div>

                <div className="group">
                  <span>追号期数：</span>
                  <div className="tools" key = {this.chaseConfig.chaseIssues}>
                    <span className="reduce" onClick={this.numberReduce.bind(this, 'chaseIssues')}>-</span>
                    <input type="number" defaultValue={this.chaseConfig.chaseIssues} ref='chaseIssues' onBlur={this.handleOnBlur.bind(this, 'chaseIssues')} onChange={this.handleInputChange.bind(this, 'chaseIssues')} />
                    <span className="add" onClick={this.numberAdd.bind(this, 'chaseIssues')}>+</span>
                  </div>
                </div>

              </span>

            </div>
          </div>{/* zCon ---end--- */}

          <div className="zList">
            <div className="tableBox">
              <table cellSpacing="0" cellPadding="0">
                <tbody>
                <tr>
                  <th>操作</th>
                  <th>追号</th>
                  <th>奖期</th>
                  <th>倍数</th>
                  <th>金额</th>
                  <th>开奖时间</th>
                </tr>
                {
                  this.endResult && this.endResult.length > 0 ? this.endResult.map((row, index) => {
                    return index < 200 ?
                      <tr key={index}>
                        <td>
                          <span className={row.checked ? 'checkBtn checked' : 'checkBtn unCheck'} onClick={this.handleCheckboxChange.bind(this, row)}></span>
                        </td>
                        <td>{index + 1}</td>
                        <td>{row.issue}</td>
                        <td>
                          <input type="number" value={row.times ? row.times : 0} disabled={row.checked ? false : true} className="input" onChange={this.handleInputChangeTimes.bind(this, row, 'trRef' + index)} ref={"trRef" + index} />倍
                        </td>
                        <td>
                          <span className="red">
                            ￥<span>{row.money ? row.money : '0.00'}</span>
                          </span>
                        </td>
                        <td>{row.saleend}</td>
                      </tr>:null
                  }) : null
                }
                </tbody>
              </table>
            </div>
            <div className="header">
              <span className="text_zh">单期注数：<b className="lt_trace_num">{this.chaseConfig.totalNum}</b>追号总期数：<b className="orange lt_trace_count">{this.chaseConfig.totalIssues}</b>追号总金额：<b className="red lt_trace_hmoney">{this.chaseConfig.totalMoney}</b></span>
              <span className="save_zh" onClick={this.save}>确认追号</span>
              <span className="cancel_zh" onClick={this.cancel}>取消追号</span>
            </div>
          </div>

        </div>
      </div>
    );
  }
}

reactMixin(TraceBox.prototype, ImmutableMixin);

function mapStateToProps(state) {
  return {
    __BASE: state.base,
    __LOTTERY: state.lottery,
    __METHOD: state.method
  }
}

function mapDispatchToProps(dispatch) {
  return {
    $$BASE: bindActionCreators(baseAction, dispatch),
    $$LOTTERY: bindActionCreators(lotteryAction, dispatch)
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TraceBox)